// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageTour_main__T-VjK {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 20px;
    padding-right: 20px;
    gap: 20px;
    margin-bottom: 40px;
}
.PageTour_containerHeaderInfoWins__ETS5E{
    display: flex;
    flex-direction: column;
    gap:10px;
    align-items: flex-start;
}
.PageTour_wrapperHeader__vWwNd{
    display: flex;
    align-items: center;
}
.PageTour_containerInfoWins__8R7NQ {

    display: flex;
    padding: 10px;
    justify-content: center;
    background-size: cover;
    /* Чтобы изображение занимало весь экран */
    background-position: center;
    /* Центрируем изображение */
    position: relative;
    /* Для псевдоэлементов */
    overflow: hidden;
    flex-direction: column;
    gap:30px;
    border-radius: 10px;
    box-shadow: 0 5px 10px 0 #000;
    /* Обрезаем элементы, выходящие за пределы контейнера */
}
.PageTour_description__zBJf-{
    font-size: 18.5px;
    color:white;
    background-color: rgba(28, 39, 54, 0.791);
    padding: 5px;
    border-radius: 10px;
    font-family: Popins,sans-serif; 
    font-weight: 500;
    text-align: center;
}
.PageTour_InfWin__7VvBH {

    font-size: 20px;
    color: white;
    font-family: Popins, sans-serif;
    z-index: 2;
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
}
.PageTour_containerPlace__t9Sv9 .PageTour_win__ok-HK{
    color: greenyellow;

}
.PageTour_containerPlace__t9Sv9 .PageTour_win__ok-HK.PageTour_dop__pl4-g {
    display: flex;
    align-items: center;
    gap:5px;
    color:gold;
}

.PageTour_containerPlace__t9Sv9 {
    display: flex;
    padding: 10px;
    justify-content: space-between;
    align-items: center;
    background-color: rgb(28 39 54);
    border-radius: 10px;
    gap:10px;
    

}

.PageTour_containerUsers__iWejq{
    display: flex;
    
    
    padding: 10px;
    border-radius: 10px;
    flex-direction: column;
    gap:10px;
    width: 100%;

}
.PageTour_containerUser__4b3vx{
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 10px;
}
.PageTour_wrapperCoins__YogDc{
    display: flex;
    align-items: center;
    gap:5px;
}
.PageTour_dop_desc__HBGYu{
    display: flex;
    flex-direction: row;
    gap:5px;
    
    color: white;
    font-family: monospace,sans-serif;
    font-size: 18px;

}
.PageTour_wrapperDopDesc__YY9Ir{
    display: flex;
    flex-direction: column;
    gap:5px;
    padding: 0 10px 0 10px;
}
.PageTour_wrapperDopDesc__YY9Ir .PageTour_dop_button__S0LKz{
    color:rgba(255, 255, 255, 0.458);
    font-size: 15px;
    font-family: Popins,sans-serif;
    cursor: pointer;
}
.PageTour_headerTable__zgf1m{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    
    background-color: rgba(24, 39, 61, 0.5);
    box-shadow: 0 5px 10px 0 #000b;
    border-color: white;
    border-radius: 10px;
    border-end-end-radius: 0;
    border-end-start-radius: 0;
    
    color:white;
    font-size: 20px;
    font-family: Popins,sans-serif;
    letter-spacing: 0.5px;
}
.PageTour_wrapperTable__OkYVR{
    display: flex;
    flex-direction: column;

}
.PageTour_wrapperUsers__t8117{
    display: flex;
    width: 100%;
    background-color: rgba(28, 39, 54, 0.369);
    box-shadow: 0 5px 10px 0 #000b;
    border-radius: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.PageTour_infoPlace__rpDM8{
    color:rgba(255, 255, 255, 0.522);
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
    position: absolute;

}
.PageTour_infoUser__P4pqS{
    display: flex;
    justify-content: space-between;
    width: 100%;
    color:white;
    font-size: 19px;
    font-family: Popins,sans-serif;
    letter-spacing: 1px;
    padding-left: 30px;

}
.PageTour_containerUser__4b3vx::after{
    
    background: linear-gradient(90deg, #0000 0, #64646480 33%, #64646480 66%, #0000) content-box;
    bottom: -10px;
    box-sizing: border-box;
    content: "";
    height: 1px;
    left: 0;
    padding: 0 25px;
    position: absolute;
    width: 100%;
    z-index: 1;
}

.PageTour_gamecard_window__mjvpZ {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
}

.PageTour_containerTime__rXrlH {
    display: flex;
    flex-direction: column;
    background-color: rgb(28 39 54);
    padding: 10px;
    border-radius: 10px;
    gap: 10px;
}

.PageTour_containerHeader__dD73k {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px 0 10px;
}
@media screen and (max-width: 800px) {
    
    .PageTour_wrapperUsers__t8117{
        flex-direction: column;
    }
    .PageTour_description__zBJf-{
        max-width: 100%;
        
    }
}
@media screen and (max-width: 1000px) {
    .PageTour_dop_desc__HBGYu{
        flex-direction: column;
    }
    
    .PageTour_main__T-VjK{
        margin-top: 70px;
        padding: 3px;
        
        
    }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Tournaments/components/PageTour/PageTour.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;;IAEI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,0CAA0C;IAC1C,2BAA2B;IAC3B,2BAA2B;IAC3B,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,6BAA6B;IAC7B,uDAAuD;AAC3D;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;IACzC,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;AACtB;AACA;;IAEI,eAAe;IACf,YAAY;IACZ,+BAA+B;IAC/B,UAAU;IACV,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,kBAAkB;;AAEtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,OAAO;IACP,UAAU;AACd;;AAEA;IACI,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB,QAAQ;;;AAGZ;;AAEA;IACI,aAAa;;;IAGb,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;IACR,WAAW;;AAEf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,OAAO;AACX;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,OAAO;;IAEP,YAAY;IACZ,iCAAiC;IACjC,eAAe;;AAEnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,sBAAsB;AAC1B;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;;IAEb,uCAAuC;IACvC,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,0BAA0B;;IAE1B,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;;AAE1B;AACA;IACI,aAAa;IACb,WAAW;IACX,yCAAyC;IACzC,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,gCAAgC;IAChC,yCAAyC;IACzC,eAAe;IACf,kBAAkB;;AAEtB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;;AAEtB;AACA;;IAEI,4FAA4F;IAC5F,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,OAAO;IACP,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;;IAEI;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;;IAEnB;AACJ;AACA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,YAAY;;;IAGhB;AACJ","sourcesContent":[".main {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-left: 20px;\n    padding-right: 20px;\n    gap: 20px;\n    margin-bottom: 40px;\n}\n.containerHeaderInfoWins{\n    display: flex;\n    flex-direction: column;\n    gap:10px;\n    align-items: flex-start;\n}\n.wrapperHeader{\n    display: flex;\n    align-items: center;\n}\n.containerInfoWins {\n\n    display: flex;\n    padding: 10px;\n    justify-content: center;\n    background-size: cover;\n    /* Чтобы изображение занимало весь экран */\n    background-position: center;\n    /* Центрируем изображение */\n    position: relative;\n    /* Для псевдоэлементов */\n    overflow: hidden;\n    flex-direction: column;\n    gap:30px;\n    border-radius: 10px;\n    box-shadow: 0 5px 10px 0 #000;\n    /* Обрезаем элементы, выходящие за пределы контейнера */\n}\n.description{\n    font-size: 18.5px;\n    color:white;\n    background-color: rgba(28, 39, 54, 0.791);\n    padding: 5px;\n    border-radius: 10px;\n    font-family: Popins,sans-serif; \n    font-weight: 500;\n    text-align: center;\n}\n.InfWin {\n\n    font-size: 20px;\n    color: white;\n    font-family: Popins, sans-serif;\n    z-index: 2;\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n.containerPlace .win{\n    color: greenyellow;\n\n}\n.containerPlace .win.dop {\n    display: flex;\n    align-items: center;\n    gap:5px;\n    color:gold;\n}\n\n.containerPlace {\n    display: flex;\n    padding: 10px;\n    justify-content: space-between;\n    align-items: center;\n    background-color: rgb(28 39 54);\n    border-radius: 10px;\n    gap:10px;\n    \n\n}\n\n.containerUsers{\n    display: flex;\n    \n    \n    padding: 10px;\n    border-radius: 10px;\n    flex-direction: column;\n    gap:10px;\n    width: 100%;\n\n}\n.containerUser{\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 10px;\n}\n.wrapperCoins{\n    display: flex;\n    align-items: center;\n    gap:5px;\n}\n.dop_desc{\n    display: flex;\n    flex-direction: row;\n    gap:5px;\n    \n    color: white;\n    font-family: monospace,sans-serif;\n    font-size: 18px;\n\n}\n.wrapperDopDesc{\n    display: flex;\n    flex-direction: column;\n    gap:5px;\n    padding: 0 10px 0 10px;\n}\n.wrapperDopDesc .dop_button{\n    color:rgba(255, 255, 255, 0.458);\n    font-size: 15px;\n    font-family: Popins,sans-serif;\n    cursor: pointer;\n}\n.headerTable{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px;\n    \n    background-color: rgba(24, 39, 61, 0.5);\n    box-shadow: 0 5px 10px 0 #000b;\n    border-color: white;\n    border-radius: 10px;\n    border-end-end-radius: 0;\n    border-end-start-radius: 0;\n    \n    color:white;\n    font-size: 20px;\n    font-family: Popins,sans-serif;\n    letter-spacing: 0.5px;\n}\n.wrapperTable{\n    display: flex;\n    flex-direction: column;\n\n}\n.wrapperUsers{\n    display: flex;\n    width: 100%;\n    background-color: rgba(28, 39, 54, 0.369);\n    box-shadow: 0 5px 10px 0 #000b;\n    border-radius: 10px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n.infoPlace{\n    color:rgba(255, 255, 255, 0.522);\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 16px;\n    position: absolute;\n\n}\n.infoUser{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    color:white;\n    font-size: 19px;\n    font-family: Popins,sans-serif;\n    letter-spacing: 1px;\n    padding-left: 30px;\n\n}\n.containerUser::after{\n    \n    background: linear-gradient(90deg, #0000 0, #64646480 33%, #64646480 66%, #0000) content-box;\n    bottom: -10px;\n    box-sizing: border-box;\n    content: \"\";\n    height: 1px;\n    left: 0;\n    padding: 0 25px;\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n}\n\n.gamecard_window {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    position: relative;\n}\n\n.containerTime {\n    display: flex;\n    flex-direction: column;\n    background-color: rgb(28 39 54);\n    padding: 10px;\n    border-radius: 10px;\n    gap: 10px;\n}\n\n.containerHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 10px 0 10px;\n}\n@media screen and (max-width: 800px) {\n    \n    .wrapperUsers{\n        flex-direction: column;\n    }\n    .description{\n        max-width: 100%;\n        \n    }\n}\n@media screen and (max-width: 1000px) {\n    .dop_desc{\n        flex-direction: column;\n    }\n    \n    .main{\n        margin-top: 70px;\n        padding: 3px;\n        \n        \n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `PageTour_main__T-VjK`,
	"containerHeaderInfoWins": `PageTour_containerHeaderInfoWins__ETS5E`,
	"wrapperHeader": `PageTour_wrapperHeader__vWwNd`,
	"containerInfoWins": `PageTour_containerInfoWins__8R7NQ`,
	"description": `PageTour_description__zBJf-`,
	"InfWin": `PageTour_InfWin__7VvBH`,
	"containerPlace": `PageTour_containerPlace__t9Sv9`,
	"win": `PageTour_win__ok-HK`,
	"dop": `PageTour_dop__pl4-g`,
	"containerUsers": `PageTour_containerUsers__iWejq`,
	"containerUser": `PageTour_containerUser__4b3vx`,
	"wrapperCoins": `PageTour_wrapperCoins__YogDc`,
	"dop_desc": `PageTour_dop_desc__HBGYu`,
	"wrapperDopDesc": `PageTour_wrapperDopDesc__YY9Ir`,
	"dop_button": `PageTour_dop_button__S0LKz`,
	"headerTable": `PageTour_headerTable__zgf1m`,
	"wrapperTable": `PageTour_wrapperTable__OkYVR`,
	"wrapperUsers": `PageTour_wrapperUsers__t8117`,
	"infoPlace": `PageTour_infoPlace__rpDM8`,
	"infoUser": `PageTour_infoUser__P4pqS`,
	"gamecard_window": `PageTour_gamecard_window__mjvpZ`,
	"containerTime": `PageTour_containerTime__rXrlH`,
	"containerHeader": `PageTour_containerHeader__dD73k`
};
export default ___CSS_LOADER_EXPORT___;
